import React, { useState } from "react";
import * as XLSX from "xlsx";
import { Table, Upload, Button, message, Card, Typography, Space } from "antd";
import { UploadOutlined, SendOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title, Text } = Typography;

const ExcelUploader = () => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [uploadKey, setUploadKey] = useState(Date.now()); // 🔑 força reset do Upload

  const handleFileChange = (info) => {
    const file = info.file.originFileObj || info.fileList?.[0]?.originFileObj;
    if (!file) return;

    setFileName(file.name);
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        if (json.length > 0) {
          const cols = Object.keys(json[0]).map((key) => ({
            title: key,
            dataIndex: key,
            key: key,
          }));

          setColumns(cols);
          setData(json);
          message.success(`Ficheiro ${file.name} carregado com sucesso!`);
        } else {
          message.warning("O ficheiro Excel está vazio!");
        }

     
        setUploadKey(Date.now());
      } catch (err) {
        console.error("Erro ao processar o ficheiro:", err);
        message.error("Erro ao ler o ficheiro Excel!");
      }
    };

    reader.readAsBinaryString(file);
  };

const handleUpload = async () => {
  if (data.length === 0) {
    message.error("Nenhum dado para enviar!");
    return;
  }

  setLoading(true);

  try {
    const response = await axios.post("https://api-movicel.technext.ao/api/import", {
      senha: "$897382?3289328918390123898213012asfmkasnfJUJH()832e",
      data,
    });

    // Se chegou aqui, é porque o status é 2xx
    if (response.data.success) {
      message.success("Dados enviados com sucesso!");
    } else {
      message.warning(response.data.message || "Algo inesperado aconteceu.");
    }

    // Limpa os dados após sucesso
    setData([]);
    setColumns([]);
    setFileName("");
    setUploadKey(Date.now());
  } catch (error) {
    // Trata erros HTTP
    if (error.response) {
      if (error.response.status === 403) {
        message.error(error.response.data.error || "Acesso não autorizado!");
      } else {
        message.error(
          `Erro ${error.response.status}: ${
            error.response.data.message || "Falha ao enviar dados!"
          }`
        );
      }
    } else if (error.request) {
      message.error("Sem resposta do servidor!");
    } else {
      message.error("Erro inesperado ao enviar os dados!");
    }

    console.error("Detalhes do erro:", error.response || error);
  } finally {
    setLoading(false);
  }
};


  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f5f7fa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px",
      }}
    >
      <Card
        style={{
          width: "90%",
          maxWidth: "1000px",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          backgroundColor: "#fff",
          padding: "30px",
        }}
      >
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <div style={{ textAlign: "center" }}>
            <Title level={3} style={{ marginBottom: 0, color: "#004aad" }}>
              Importador de Dados Excel
            </Title>
            <Text type="secondary">
              Carregue um ficheiro Excel (.xlsx) para visualizar e enviar os dados.
            </Text>
          </div>

          {/* ✅ key dinâmica garante reset após ler qualquer ficheiro */}
          <Upload
            key={uploadKey}
            accept=".xlsx, .xls"
            showUploadList={false}
            beforeUpload={() => false}
            onChange={handleFileChange}
          >
            <Button
              icon={<UploadOutlined />}
              type="primary"
              style={{
                background: "#004aad",
                borderRadius: "8px",
                height: "40px",
              }}
            >
              Selecionar ficheiro Excel
            </Button>
          </Upload>

          {fileName && (
            <Text type="success" strong>
              Ficheiro selecionado: {fileName}
            </Text>
          )}

          {data.length > 0 && (
            <>
              <Table
                columns={columns}
                dataSource={data}
                rowKey={(record, index) => index}
                pagination={{ pageSize: 8 }}
                bordered
                size="middle"
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  background: "#fafafa",
                }}
              />

              <div style={{ textAlign: "right" }}>
                <Button
                  type="primary"
                  icon={<SendOutlined />}
                  loading={loading}
                  onClick={handleUpload}
                  style={{
                    background: "#00b96b",
                    border: "none",
                    borderRadius: "8px",
                    height: "40px",
                  }}
                >
                  Enviar para o servidor
                </Button>
              </div>
            </>
          )}
        </Space>
      </Card>
    </div>
  );
};

export default ExcelUploader;
